import {
    RateCardsData,
} from 'app/requests/RateCard/RateCard.types'
import {
    TypeIcon,
} from 'app/shared-components/NotificationIcon/notificationIcon.types'
import {
    WithId,
} from 'app/types/common.types'
import {
    FieldInCard, NestedField,
} from 'app/types/form.types'

import {
    getCollectionOptions, getValue,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.utils'
import TooltipContentCollectionService
    from '../AccountLaneTooltipContent/TooltipContentCollectionService'
import {
    AccountLaneFormFields,
} from '../AccountLaneForm.fields'

export default ({
    disabled,
    getAllowedValues,
    logisticDetails,
    isCollection,
    isStatusPriced,
    collectionDropoffPointCountry,
}: {
    disabled?: boolean,
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    logisticDetails?: RateCardsData,
    isCollection?: boolean,
    isStatusPriced?: boolean,
    collectionDropoffPointCountry?: WithId<number>,
}): FieldInCard<keyof AccountLaneFormFields>[] => {
    return [
        {
            id: 'column1',
            fields: [
                {
                    name: 'collectionServiceType',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(getCollectionOptions({
                        destinationCollectionLtl: logisticDetails?.destinationCollectionLtl,
                    })),
                    labelKey: 'AccountLane.collectionServiceType',
                    notificationIconProps: {
                        content: TooltipContentCollectionService,
                        type: TypeIcon.INFO,
                    },
                    required: true,
                    useDropdown: true,
                    disabled: disabled || isStatusPriced,
                },
                {
                    name: 'destinationCollectionLtl',
                    componentName: 'InputSingleline',
                    value: getValue(logisticDetails?.destinationCollectionLtl),
                    disabled: true,
                    className: logisticDetails?.destinationCollectionLtl && 'green',
                    labelKey: 'AccountQuotes.destinationCollectionLTL',
                },
            ],
        },
        {
            id: 'column2',
            fields: [
                ...(isCollection ? [
                    {
                        name: 'collectionDropoffPointCountry',
                        componentName: 'CountryDataSelector',
                        labelKey: 'AccountLane.collectionDropoffPointCountry',
                        required: true,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'collectionDropoffPointZipCode',
                        componentName: 'ZipCodeInput',
                        labelKey: 'AccountLane.collectionDropoffPointZipCode',
                        required: true,
                        country: collectionDropoffPointCountry,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'collectionDropoffPointAddress',
                        componentName: 'InputSingleline',
                        labelKey: 'AccountLane.collectionDropoffPointAddress',
                        disabled,
                    },
                ] as NestedField<keyof AccountLaneFormFields>[] : []),
                {
                    name: 'collectionDropoffPointContacts',
                    componentName: 'MultipleContactObjectSelector',
                    labelKey: 'AccountLane.collectionDropoffPointContacts',
                    disabled,
                },
            ],
        },
    ]
}
